import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM7 1.07692C10.2695 1.07692 12.9231 3.73046 12.9231 7C12.9231 10.2695 10.2695 12.9231 7 12.9231C3.73046 12.9231 1.07692 10.2695 1.07692 7C1.07692 3.73046 3.73046 1.07692 7 1.07692Z",
			fill: "#4B4B4B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.07637 3.90388C8.07637 4.22521 7.94873 4.53338 7.72152 4.76059C7.49432 4.9878 7.18616 5.11545 6.86485 5.11545C6.54353 5.11545 6.23537 4.9878 6.00817 4.76059C5.78096 4.53338 5.65332 4.22521 5.65332 3.90388C5.65332 3.58256 5.78096 3.27439 6.00817 3.04718C6.23537 2.81997 6.54353 2.69232 6.86485 2.69232C7.18616 2.69232 7.49432 2.81997 7.72152 3.04718C7.94873 3.27439 8.07637 3.58256 8.07637 3.90388Z",
			fill: "#4B4B4B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.14906 10.3342C8.14163 10.6282 8.27948 10.7111 8.61505 10.7456L9.15437 10.7563V11.3077H4.94651V10.7563L5.53914 10.7456C5.89356 10.7348 5.97874 10.5969 6.00513 10.3342V7.01585C6.0089 6.49042 5.3271 6.57291 4.84668 6.58853V6.0421L8.14906 5.9231",
			fill: "#4B4B4B"
		})
	]
});
export default SvgMoreInfo;
